import React, { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import necrolog from '../images/necrolog.jpg';

const Necrology = () => {
  const location = useLocation();

  useEffect(() => {
    if (location.hash) {
      const element = document.querySelector(location.hash);
      if (element) {
        element.scrollIntoView({ behavior: 'smooth' });
      }
    }
  }, [location]);
  return (
    <>
      {/* <div className="container max-w-screen-lg pt-3 pb-3 ">
        <div className="flex flex-col justify-center md:flex-row">
          <h1 className="py-3 text-3xl md:text-5xl font-bold text-[#A81414] ">Некролог</h1>
          
        </div>
      </div> */

        <iframe
          src="../necrolog.pdf"
          className="hidden md:flex w-full h-[calc(100vh-120px)]"
          title="PDF Viewer"
        ></iframe>
      }
      {
        //  <a href="/nekrology" className="relative">
        //       <div className="!rounded-xl pt-1 absolute left-[50%] -translate-x-2/4	 text-white z-90 bg-black h-full w-full opacity-10"></div>
        //        <p
        //           className="!rounded-tl-lg !rounded-br-lg !border-0 !normal-case !bg-[#A81414] !text-md md:!text-[20px] !py-1 !absolute !top-[0px] !left-[0px] !text-white !z-100 !w-[100%] max-w-max !text-center !hover-underline-animation px-2"
        //       >
        //         Некролог
        //       </p>
        //       <img className="!rounded-xl object-cover w-full h-60 object-right" src={necrolog} alt="" />
        //       <img className="absolute bottom-0 right-0 !rounded-xl object-cover object-top w-[44px] h-[44px] " src={"images/link-to.png"} alt="" />
        //     </a>
        <div>
          <a
            href="/necrolog.pdf"
            target="_blank"
            rel="noopener noreferrer"
            className="block mb-3 text-center text-blue-600 underline md:hidden"
          >
                      <img className="!rounded-xl object-cover w-full h-60 object-right" src={necrolog} alt="" />

          </a>

        </div>
      }
    </>
  );
};

export default Necrology;
